import { useState } from 'react'
import PropTypes from 'prop-types'
import { InfoButton } from 'components/buttons'
import PostCardRow from 'hello_baby/components/post-card-row'
import { StyledSubHeading } from '../../../components/headings'
import * as blUrls from 'lib/urls'

const ShopByGuides = ({ guides }) => {
  if (guides && guides.length >= 2) {
    return (
      <div className="mtxl">
        <StyledSubHeading
          style={{ fontSize: '24px' }}
          className="text-bold text-center"
        >
          Shop by Guide
        </StyledSubHeading>
        <PostCardRow
          className="mtxl"
          columns={3}
          navigateWithRouter={false}
          posts={guides}
        />
        <div className="mvl text-center">
          <InfoButton href={blUrls.helloBabyPath}>See All Guides</InfoButton>
        </div>
      </div>
    )
  } else {
    return null
  }
}

ShopByGuides.propTypes = {
  guides: PropTypes.array,
}

export default ShopByGuides
